





















import { Vue, Component, Prop } from 'vue-property-decorator';
import ObjectFitImages from 'object-fit-images';
import { IField } from '@/dealroom/fields/types/field';
import FieldContentContainer from '@/dealroom/fields/components/FieldContentContainer.vue';
import Icon from '@/components/Icon.vue';
import { EFieldSource } from '@/api/fields/types/field-source';

@Component({
  components: {
    FieldContentContainer,
    Icon,
  },
})
export default class SignatureField extends Vue {
  @Prop() field: IField;
  @Prop() senderSignature: string;
  @Prop() isActive: boolean;
  @Prop() showInitials: boolean;

  get isSender(): boolean {
    return this.field.source === EFieldSource.Sender;
  }

  get isRequired(): boolean {
    return this.field.isRequired;
  }

  get hasValue(): boolean {
    return !!this.field.value;
  }

  get showSignature(): boolean {
    return this.isSender && !!this.field.signatureBiometric;
  }

  get imageAltText(): string {
    const source: string = this.isSender
      ? this.$t('sender').toString()
      : this.$t('recipient').toString();
    return `${source} ${this.$t('signature')}`;
  }

  errorSignature(event) {
    event.target.src = '/assets/img/signature.gif';
  }

  mounted() {
    ObjectFitImages();
  }
}
